export default class TrustindexReviewWidget {
	constructor(widget)
	{
		widget.reviewTextMode = widget.getAttribute('data-review-text-mode') || 'readmore';
		widget.reviewsContainer = widget.querySelector('.ti-reviews-container');
		widget.reviewsContainerWrapper = widget.querySelector('.ti-reviews-container-wrapper');
		widget.locales.time = widget.getAttribute('data-time-locale');
		widget.locales.replyBy = widget.getAttribute('data-reply-by-locale');
		widget.locales.onlyRating = widget.getAttribute('data-only-rating-locale');
		if (!widget.locales.onlyRating && 'en' === widget.language) {
			widget.locales.onlyRating = 'This user only left a rating.';
		}

		widget.isCompanyBadge = widget.container.offsetWidth > widget.reviewsContainer.offsetWidth;
		widget.reviewTargetWidth = parseInt(widget.getAttribute('data-review-target-width') || (widget.isCompanyBadge ? 275 : 300));

		this.widget = widget;
		this.widget.originalColCount = this.getColCount();

		this.initHeaderClick();
	}

	getReviews()
	{
		let result = [];

		this.widget.reviewsContainer.querySelectorAll('.ti-review-item:not(.ti-cloned)').forEach(reviewItem => {
			let text = "";
			let language = "-";
			let rating = reviewItem.querySelectorAll('.ti-stars .ti-star.f').length + (reviewItem.querySelectorAll('.ti-stars .ti-star.h').length/2);
			let createdAt = (new Date(parseInt(reviewItem.getAttribute('data-time')) * 1000)).toISOString().replace('Z', '+00:00');
			let textContainer = reviewItem.querySelector('.ti-review-text-container');

			if (textContainer && !textContainer.classList.contains('ti-empty-text')) {
				text = this.getReviewText(textContainer);
				language = reviewItem.getAttribute('data-language') || null;
			}

			result.push({
				id: reviewItem.getAttribute('data-id') || null,
				url: reviewItem.getAttribute('data-platform-page-url') || null,
				language: language,
				createdAt: createdAt,
				reviewerName: reviewItem.querySelector('.ti-name').textContent.trim(),
				reviewBody: text,
				rating: reviewItem.getAttribute('data-rating') || rating,
				maxRating: parseInt(reviewItem.getAttribute('data-max-rating') || 0),
			});
		});

		return result;
	}

	getReviewText(textContainer)
	{
		let replyTitle = textContainer.querySelector('.ti-reply-by-owner-title');
		let text = '';

		if (textContainer.querySelector('.ti-show-original-text')) {
			let json = Trustindex.parseJsonData(Trustindex.getJsonDataElement(textContainer));
			return json.text || json;
		}

		if (replyTitle) {
			let node = textContainer.firstChild;
			while (node && node !== replyTitle) {
				if (node.nodeType === Node.TEXT_NODE) {
					text += node.textContent;
				}
				if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'SCRIPT') {
					text += node.textContent;
				}

				node = node.nextSibling;
			}
		} else {
			text = textContainer.textContent;
		}

		return text.trim();
	}

	format()
	{
		this.widget.isCompanyBadge = this.widget.container.offsetWidth > this.widget.reviewsContainer.offsetWidth;

		this.widget.reviewsContainer.querySelectorAll('.ti-review-item').forEach(reviewItem => this.formatReview(reviewItem));
	}

	formatReview(reviewItem)
	{
		let textContainer = reviewItem.querySelector('.ti-review-text-container');
		if (textContainer) {
			this.formatReviewText(textContainer);

			// IOS fallback for review images with float inside -webkit-box
			//	- as of 2024-07-30 float not working in -webkit-box so we change review-text-container to block to work
			if (!textContainer.classList.contains('ti-empty-text')) {
				textContainer.querySelectorAll('.ti-review-image').forEach(imageContainer => {
					let span = document.createElement('span');
					span.textContent = '\u200b';
					imageContainer.after(span);

					if (span.offsetTop - imageContainer.offsetTop > 20) {
						this.widget.classList.add('ti-ios-fallback');
					}

					span.remove();
				});
			}
		}

		// page url open on name click
		let url = reviewItem.getAttribute('data-platform-page-url');
		if (url && url.indexOf('trustpilot.com') !== -1) {
			let name = reviewItem.querySelector('.ti-name');
			if (name) {
				name.style.cursor = 'pointer';
				name.addEventListener('click', event => Trustindex.openWindow(url));
			}
		}

		// modern date (x day/week/month/year ago)
		let timeStamp = reviewItem.getAttribute('data-time');
		if (timeStamp && this.widget.locales.time) {
			let date = reviewItem.querySelector('.ti-date:not(.ti-date-comment)');
			if (date) {
				let dateStr = (new Date(timeStamp * 1000)).toLocaleString(Trustindex.getLocaleTag(this.widget.language), {
					year: "numeric",
					month: "long",
					day: "numeric",
					hour: "numeric",
					minute: "numeric",
					timeZoneName: "short",
				});

				date.innerHTML = `
					<span class="ti-with-tooltip">
						<span class="ti-tooltip" style="display:none">${dateStr}</span>
						${Trustindex.getRelativeTime(parseInt(timeStamp), this.widget.locales.time)}
					</span>
				`;

				let tooltip = date.querySelector('.ti-tooltip');
				tooltip.style.width = tooltip.firstChild.offsetWidth + 'px';
			}
		}

		// replace wrong profile images
		Trustindex.profileImageFallback(reviewItem);
	}

	formatReviewText(textContainer)
	{
		let svgs = textContainer.querySelectorAll('svg');
		if (0 === svgs.length) {
			// optimizers can add line breaks around the review image, these must not be converted to <br />
			textContainer.querySelectorAll('.ti-review-image').forEach(imageContainer => {
				[imageContainer.previousSibling, ...imageContainer.childNodes]
					.filter(node => node && Node.TEXT_NODE === node.nodeType && '' === node.textContent.trim())
					.forEach(node => node.remove());
			});

			let html = textContainer.innerHTML;

			// PRO-KONTRA - Wordpress Plugins
			html = html
				.replace(/<img[^>]+class="emoji" alt="\u263a" src="[^'"]+">/gm, Trustindex.svgs.good + '&nbsp;&middot;&nbsp;')
				.replace(/<img[^>]+class="emoji" alt="\u2639" src="[^'"]+">/gm, Trustindex.svgs.bad + '&nbsp;&middot;&nbsp;');

			// PRO-KONTRA
			let classList = textContainer.closest('.ti-review-item').classList;
			if (classList.contains('source-Booking') || classList.contains('source-Arukereso')) {
				let hasGoodPoint = -1 !== html.indexOf('\u263a');
				html = html
					.replace(/\s+\u263a/g, '<br /><br />' + Trustindex.svgs.good + '&nbsp;&middot;&nbsp;')
					.replace(/\s+\u2639/g, (hasGoodPoint ? '<br />' : '<br /><br />') + Trustindex.svgs.bad + '&nbsp;&middot;&nbsp;');
			}

			// nl2brs
			html = html.replace(/\n/g, '<br />');

			textContainer.innerHTML = html;
			Trustindex.decodeTextNodes(textContainer);

			svgs = textContainer.querySelectorAll('svg');
		}

		if (svgs.length) {
			let size = parseInt(textContainer.style.fontSize || 14) * 0.95;
			svgs.forEach(svg => {
				svg.style.width = size + 'px';
				svg.style.height = size + 'px';
			});
		}

		let text = textContainer.innerHTML.trim()
			.replace(/<!-- R-CONTENT -->/g, '')
			.replace(/<br\s?\/?>/g, '')
			.replace(/<span class="ti-reply-by-owner-title">.*/s, '')
			.replace(/<div class="ti-more-image-count">[\d+]+<\/div>/g, '')
			.replace(/<div class="ti-review-image[^"]*"[^>]*><img[^>]*><\/div>/g, '')
		;

		if (!text) {
			let textHasReviewImage = textContainer.innerHTML.includes('<div class="ti-review-image');

			textContainer.innerHTML =
				textHasReviewImage ?
					textContainer.innerHTML + this.widget.locales.onlyRating
					: this.widget.locales.onlyRating + textContainer.innerHTML
			;
		}
	}

	resize()
	{
		let containerWidth = this.widget.reviewsContainer.offsetWidth;
		if (this.widget.isCompanyBadge && typeof this.widget.TrustindexSliderWidget !== 'undefined' && this.widget.TrustindexSliderWidget.footer) {
			if (undefined === this.companyBadgeWidth) {
				this.companyBadgeWidth = this.widget.TrustindexSliderWidget.footer.offsetWidth;

				let style = window.getComputedStyle(this.widget.TrustindexSliderWidget.footer, null);
				this.companyBadgeWidth += parseInt(style.getPropertyValue('margin-left'));
				this.companyBadgeWidth += parseInt(style.getPropertyValue('margin-right'));
			}

			containerWidth = this.widget.container.offsetWidth - this.companyBadgeWidth;
		}

		let colCount = Math.floor(containerWidth / this.widget.reviewTargetWidth);

		if (colCount > 1 && 44 === this.widget.layoutId) {
			colCount--;
		}

		colCount = Math.min(colCount, this.getReviewCount());

		if (this.widget.isCompanyBadge) {
			if (containerWidth < 350) {
				colCount = 0;
			}

			this.widget.container.setAttribute('class', 'ti-widget-container ti-col-' + (colCount + 1));
		}
		else {
			if (colCount < 1) {
				colCount = 1;
			}

			this.widget.container.setAttribute('class', 'ti-widget-container ti-col-' + colCount);
		}

		console.log('[Trustindex Widget: '+this.widget.pid+' - '+this.widget.layoutId+'] resized');
	}

	resizeAfter()
	{
		// set width for verified review tooltips
		let toolTipWidth = 0;
		this.widget.reviewsContainer.querySelectorAll('.ti-verified-review.ti-verified-platform').forEach(icon => {
			let tooltip = icon.querySelector('.ti-verified-tooltip');

			if (!toolTipWidth) {
				let style = getComputedStyle(tooltip);

				toolTipWidth = icon.parentNode.offsetWidth - icon.offsetLeft - 5;
				if (parseInt(style.left) < 0) {
					toolTipWidth = icon.offsetLeft - icon.parentNode.offsetLeft - 5;
				}
			}

			tooltip.style.width = toolTipWidth + 'px';
		});
	}

	click(event)
	{
		if (event.target.matches('.ti-show-original-text')) {
			this.showOriginalText(event);

			if (typeof this.widget.TrustindexReadMoreModule !== 'undefined') {
				let reviewTextContainer = event.target.closest('.ti-review-text-container');
				this.widget.TrustindexReadMoreModule.resetReview(reviewTextContainer);
			}
		}
	}

	showOriginalText(event)
	{
		event.preventDefault();
		event.stopPropagation();

		let reviewTextContainer = event.target.closest('.ti-review-text-container');
		let json = Trustindex.parseJsonData(Trustindex.getJsonDataElement(reviewTextContainer));
		let text = typeof json.text !== 'undefined' ? json.text : json;

		let reviewImage = reviewTextContainer.querySelector('.ti-review-image');
		if (reviewImage) {
			text = reviewImage.outerHTML + text;
		}

		if (typeof json.reply !== 'undefined' && json.reply) {
			text += '<br /><br /><span class="ti-reply-by-owner-title">'+this.widget.locales.replyBy+'</span><br />'+json.reply;
		}

		reviewTextContainer.innerHTML = text;
		this.formatReviewText(reviewTextContainer);
	}

	initHeaderClick()
	{
		let a = this.widget.querySelector('a[href]:not(.ti-write-btn-dropdown-item):not(.ti-header-write-btn)');
		if (!a) {
			return;
		}

		let url = a.getAttribute('href');
		if (!url || '#' === a.getAttribute('href')) {
			return;
		}

		let container = a.closest('.ti-header:not(a), .ti-footer:not(a), .ti-popup-header:not(a)');
		if (!container || !container.querySelector('.ti-large-logo, .ti-profile-img, .ti-profile-details, .ti-logo-stars-flex') || container.querySelector('.ti-disclaimer')) {
			return;
		}

		container.classList.add('ti-clickable-link');
		container.addEventListener('click', (event) => {
			if ('A' === event.target.nodeName) {
				return false;
			}

			event.preventDefault();
			Trustindex.openWindow(url);
		});
	}

	getColCount()
	{
		let className = this.widget.container.classList.toString();

		if (-1 === className.indexOf('ti-col-')) {
			return 1;
		}

		return parseInt(className.replace(/^.*ti-col-(\d+).*$/, '$1'));
	}

	getReviewCount()
	{
		return this.widget.reviewsContainer.querySelectorAll('.ti-review-item:not(.ti-cloned)').length;
	}
};